import { render, staticRenderFns } from "./rcommendaTable.vue?vue&type=template&id=b3156a56"
import script from "./rcommendaTable.vue?vue&type=script&lang=js"
export * from "./rcommendaTable.vue?vue&type=script&lang=js"
import style0 from "./rcommendaTable.vue?vue&type=style&index=0&id=b3156a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports